export default "__VITE_ASSET__49f4c092__"